/* eslint-disable arrow-body-style */
/*
 *
 * Api reducer
 *
 */


import produce from 'immer';
import { REQUEST_DATA_RESULT } from '../../containers/App/constants';
import { WEBLOGIN_FETCH_VEHICLES, WEBLOGIN_FETCH_VEHICLE, WEBLOGIN_FETCH_VEHICLE_INVOICES } from './constants';
import { parseVehicle } from '../Vehicles/helpers';


export const initialState = {
  vehicles: null,
  vehiclesById: {},
  vehicleInvoices: [],
 
};

export const webloginReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case WEBLOGIN_FETCH_VEHICLES:
            draft.vehicles = action.result.map(parseVehicle);
            break;

          case WEBLOGIN_FETCH_VEHICLE:
            draft.vehiclesById[action.vehicleId] = parseVehicle(action.result);
            break;

          case WEBLOGIN_FETCH_VEHICLE_INVOICES:
            draft.vehicleInvoices = [...action.result.items];
            draft.paginator = action.result.paginator;
            draft.itemsCount = action.result.paginator.itemsCount;
            break;

        }
    }
  });
};
